export const SOURCES_PATH = '/onboarding/pick-sources';
export const TOPICS_PATH = '/onboarding/pick-topics';
export const ABOUT_YOU_PATH = '/onboarding/about-you';
export const ALL_DONE_PATH = '/onboarding/all-done';
